import type { InterestsConfig } from '#types/config/components/form/interests'
import type { RecursivePartial } from '#types/utils'

export default {
  showShoeSizeSelector: false
} satisfies RecursivePartial<InterestsConfig>
